module.exports = __webpack_public_path__ + "static/LGWarrantyImage-a9d893dfb3702a3e4c57245a6cfd4267.png";